import React, { useState } from "react";
import {
  FaChevronDown,
  FaCheckCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import categories from "../Allcategories/Allcategories";

const CategorySelector = ({ onCategoryDataChange }) => {
  const [categoryPath, setCategoryPath] = useState([]);
  const [experience, setInputData] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCategoryChange = (event, level) => {
    const selectedCategory = event.target.value;

    if (!selectedCategory) {
      setErrorMessage("Please select a valid category!");
      return;
    }

    const updatedCategoryPath = [
      ...categoryPath.slice(0, level),
      selectedCategory,
    ];
    setCategoryPath(updatedCategoryPath);
    setInputData(""); // Clear input when category changes
    setErrorMessage(""); // Reset error message

    // Pass updated category path back to the parent
    onCategoryDataChange("categoryPath", updatedCategoryPath);
  };

  const handleInputChange = (event) => {
    setInputData(event.target.value);
    // Pass the input data back to the parent
    onCategoryDataChange("experience", event.target.value);
  };

  const getCategoryData = (categoryPath) => {
    let categoryData = categories;
    for (const category of categoryPath) {
      categoryData = categoryData.find((cat) => cat.name === category);
      if (!categoryData) return null;
      categoryData = categoryData.services || []; // Updated to use `services` instead of `subCategories`
    }
    return categoryData;
  };

  const renderCategoryDropdown = (level) => {
    const categoryName = categoryPath[level] || "";
    const categoryData = getCategoryData(categoryPath.slice(0, level));

    if (!categoryData || categoryData.length === 0) {
      return null; // No more subcategories, don't render dropdown
    }

    return (
      <div key={level} className="mb-4">
        <label htmlFor={`category-${level}`} className="block text-gray-700">
          {level === 0
            ? "Select Main Category"
            : `Select Subcategory Level ${level + 1}`}
          :
        </label>
        <div className="flex items-center space-x-2">
          <select
            id={`category-${level}`}
            value={categoryName}
            onChange={(event) => handleCategoryChange(event, level)}
            className="p-2 border border-gray-300 rounded-md w-full"
          >
            <option value="">Select a category</option>
            {categoryData.map((cat) => (
              <option key={cat.name} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
          {categoryName ? (
            <FaCheckCircle className="text-green-500" />
          ) : (
            <FaChevronDown className="text-gray-500" />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
        <FaChevronDown className="mr-2" />
        Select Categories and Subcategories
      </h2>

      {/* Error Message */}
      {errorMessage && (
        <div className="mb-4 p-2 bg-red-200 text-red-800 rounded-md flex items-center">
          <FaExclamationTriangle className="mr-2" />
          <strong>Error: </strong>
          {errorMessage}
        </div>
      )}

      {/* Dynamic Category Dropdowns */}
      {Array.from({ length: categoryPath.length + 1 }).map((_, index) =>
        renderCategoryDropdown(index),
      )}

      {/* Input Field for Additional Data */}
      {categoryPath.length > 0 && (
        <div className="mb-4">
          <label htmlFor="experience" className="block text-gray-700">
            Enter the experience details
          </label>
          <input
            type="text"
            id="experience"
            value={experience}
            onChange={handleInputChange}
            placeholder={`Enter the experience details`}
            className="p-2 border border-gray-300 rounded-md w-full placeholder-green-500"
          />
        </div>
      )}
    </div>
  );
};

export default CategorySelector;
